import { render, staticRenderFns } from "./SuiteCreate.vue?vue&type=template&id=6e245496&scoped=true&"
import script from "./SuiteCreate.vue?vue&type=script&lang=js&"
export * from "./SuiteCreate.vue?vue&type=script&lang=js&"
import style0 from "./SuiteCreate.vue?vue&type=style&index=0&id=6e245496&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e245496",
  null
  
)

export default component.exports